import { z } from "zod";

const envSchema = z.object({
  VITE_SUPABASE_URL: z.string().url({
    message: "VITE_SUPABASE_URL deve ser uma URL válida do projeto Supabase.",
  }),
  VITE_SUPABASE_ANON_KEY: z.string().min(1, {
    message: "VITE_SUPABASE_ANON_KEY é obrigatória.",
  }),
  VITE_GOOGLE_BOOKS_API_URL: z
    .string()
    .url()
    .default("https://www.googleapis.com/books/v1/volumes"),
  VITE_APP_ENV: z.enum(["development", "staging", "production"]).default("development"),
  /**
   * Chave pública VAPID (Web Push) — Frente 2, Fase 3. Opcional de propósito:
   * se não configurada neste ambiente de build, a tela de notificações
   * degrada para "não suportado" em vez de derrubar o app inteiro para
   * todos os usuários (é a mesma chave pública já usada pela Edge Function
   * notificacoes-dispatcher via VAPID_PUBLIC_KEY no Vault).
   */
  VITE_VAPID_PUBLIC_KEY: z.string().optional().default(""),
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  console.error(
    "Variáveis de ambiente inválidas ou faltando. Verifique seu arquivo .env (veja .env.example).",
    parsed.error.flatten().fieldErrors,
  );
  throw new Error("Configuração de ambiente inválida.");
}

export const env = parsed.data;
